import { Component, Input } from '@angular/core';
import { Router } from '@angular/router';

import { BlurService } from './blur.service';
import { LogService } from './../../shared';

@Component({
  selector: 'blur',
  template: require('./blur.component.html'),
  styles: [require('./blur.component.scss')],
  providers: [BlurService]
})
export class BlurComponent {
  @Input() set itemtype(type: string) {
    this.service.setType(type);
  }

  @Input() set item(item: any) {
    this.service.setItem(item);
  }

  constructor(private logger: LogService, private service: BlurService) {
    // Do stuff
  }
}



// WEBPACK FOOTER //
// ./node_modules/angular-router-loader/src!./node_modules/angular2-template-loader!./node_modules/@angularclass/hmr-loader!./node_modules/tslint-loader!./src/app/shared/blur/blur.component.ts